import type { Category } from './categories'

interface Analytics {
  tool_name: string
  feature_flag: string
}

export const analytics: Record<Category, Analytics> = {
  laptops: {
    tool_name: 'laptop picker helper',
    feature_flag: 'DSP-032-guided-purchase-laptop-helper',
  },
  mattresses: {
    tool_name: 'mattress picker helper',
    feature_flag: 'DSP-032-guided-purchase-mattress-helper',
  },
}
